import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const jingleAudioUrl = (jobId, versionIndex) =>
  versionIndex === undefined || versionIndex === null
    ? `${API}/jingles/${jobId}/audio`
    : `${API}/jingles/${jobId}/audio/${versionIndex}`;

export const siteAudioUrl = (siteKey, batchIndex, takeIndex, bust) =>
  `${API}/sites/${siteKey}/audio/${batchIndex}/${takeIndex}${bust ? `?r=${bust}` : ""}`;

export const siteDownloadUrl = (siteKey, version, sessionId, opts = {}) => {
  const params = new URLSearchParams();
  if (sessionId) params.set("session_id", sessionId);
  if (opts.v) params.set("v", opts.v);
  if (opts.inline) params.set("inline", "1");
  const qs = params.toString();
  return `${API}/sites/${siteKey}/download/${version}${qs ? `?${qs}` : ""}`;
};

export const jingleDownloadUrl = (jobId, version, sessionId) =>
  `${API}/jingles/${jobId}/download/${version}${sessionId ? `?session_id=${sessionId}` : ""}`;
